import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/venn-diagram/pages/CalculatorPage";

export const Route = createFileRoute("/venn-diagram")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/venn-diagram",
      title: m.venn_meta_title(),
      description: m.venn_meta_description(),
      toolName: m.venn_tool_name(),
      faqs: [
        { q: m.venn_faq_q1(), a: m.venn_faq_a1() },
        { q: m.venn_faq_q2(), a: m.venn_faq_a2() },
        { q: m.venn_faq_q3(), a: m.venn_faq_a3() },
        { q: m.venn_faq_q4(), a: m.venn_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
